/* eslint-disable no-useless-escape */
import { useState } from "react";
import PropTypes from "prop-types";

export default function PLPOrderBySelect({
  orderBySelect,
  sortingArray = [],
  selectedSortOrder = "",
}) {
  const [open, setOpen] = useState(false);

  const handleSelect = option => {
    const event = {
      target: {
        id: "order-by",
        name: "order-by",
        value: option.value,
      },
    };

    orderBySelect(event);
    setOpen(false);
  };

  const selectedOption = sortingArray.find(
    item => item.value === selectedSortOrder
  );
  return (
    <div className="flex md:mt-[58px] md:mb-[55px] mx-[10px] relative md:w-1/3 w-full">
      <div className="relative w-full">
        <button
          type="button"
          id="order-by"
          name="order-by"
          className="w-full px-4 py-3 border border-[#dbdbdb] text-left bg-white font-[helveticaRoman,_Helvetica,_sans-serif] text-[#232323] py-3 px-4 pr-8 rounded"
          onClick={() => setOpen(!open)}
        >
          {selectedOption?.label || sortingArray[0]?.label}
        </button>

        {open && (
          <ul className="absolute z-10 w-full bg-white border border-[#dbdbdb] shadow-lg">
            {sortingArray?.slice(1).map(item => (
              <li
                key={item.value}
                className={`px-4 py-3 cursor-pointer border-b border-[#dbdbdb] hover:bg-[#e5e5e5] font-[helveticaRoman,_Helvetica,_sans-serif] !text-[14px] ${
                  selectedSortOrder === item.value ? "bg-[#d5d5d5]" : ""
                }`}
                onClick={() => handleSelect(item)}
              >
                {item.label}
              </li>
            ))}
          </ul>
        )}
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg
            className="fill-current h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </div>
      </div>
    </div>
  );
}

PLPOrderBySelect.propTypes = {
  orderBySelect: PropTypes.func,
  sortingArray: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  selectedSortOrder: PropTypes.string,
};

PLPOrderBySelect.defaultProps = {
  orderBySelect: () => {},
};
